import { Component, OnInit, OnChanges } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';
import { GeneralService } from '../../../services/general.service';

@Component({
  selector: 'app-video-tutorial',
  templateUrl: './video-tutorial.component.html',
  styleUrls: ['./video-tutorial.component.scss']
})
export class VideoTutorialComponent implements OnInit {

  constructor(private sesionStateService: SessionStateService,
              private generalService: GeneralService) { }

  ngOnInit() {
  }

  getACVideo(): string {
    if (this.sesionStateService.getLang() === 'PT') {
      return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/AC_PT.m4v';
    } else if (this.sesionStateService.getLang() === 'ES') {
      return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/AC_ES.m4v';
    } else {
      return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/AC_EN.m4v';
    }
  }

  getCLPVideo(): string {
    if (this.sesionStateService.getLang() === 'PT') {
      return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/CLP_PT.m4v';
    } else if (this.sesionStateService.getLang() === 'ES') {
      return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/CLP_ES.m4v';
    } else {
      return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/CLP_EN.m4v';
    }
  }

  getGeneralVideo(): string {
    if (this.sesionStateService.getLang() === 'PT') {
      return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/General_PT.m4v';
    } else if (this.sesionStateService.getLang() === 'ES') {
      return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/General_ES.m4v';
    } else {
      return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/General_EN.m4v';
    }
  }

    getProgramationVideo(): string {
      if (this.sesionStateService.getLang() === 'PT') {
        return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/Programacoes_PT.m4v';
      } else if (this.sesionStateService.getLang() === 'ES') {
        return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/Programacoes_ES.m4v';
      } else {
        return 'https://s3-eu-west-1.amazonaws.com/redy-prod-general-purpose/Public/VideoTutorials/Programacoes_EN.m4v';
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/tutorial/video-tutorial/video-tutorial.component.ts